import { useQuery } from "@tanstack/react-query";
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { useAtom } from 'jotai';
import { siteAtom } from '../../atoms/SiteAtom';
import ConvertTime from "../converters/TimestampConverter";

import {
  Card,
  CardBody,
} from 'reactstrap';

export default function SiteInfoHandler() {
  const { uid } = useParams();
  const [site, setSite] = useAtom(siteAtom);

  const fetchSiteData = async () => {
    try {
      const response = await axios.get(`https://windmonitoring.net/api/sites/${uid}`);
      const fetchedData = response.data;
      console.log("Data fetched successfully:", fetchedData);

      try {
        updateSiteDataAtom(fetchedData);
      } catch (error) {
        console.error("Error updating SiteAtom:", error);
      }

      return fetchedData; // Return data for caching by React Query
    } catch (error) {
      console.error("Error fetching data:", error);
      throw error; // Re-throw the error to be caught by React Query
    }
  };

  const { isLoading, isError, error } = useQuery({
    queryKey: ['SiteInfo', uid],
    queryFn: fetchSiteData,
    refetchOnMount: true,
    refetchOnWindowFocus: true,
  });

  function updateSiteDataAtom(fetchedData) {
    if (fetchedData) {
      const convertedTS = ConvertTime(fetchedData.LastRx);
      console.log('Converted LastRx:', convertedTS);
      setSite((prevData) => ({
        ...prevData,
        ...fetchedData,
        LastRx: convertedTS,
      }));

      console.log("Updated SiteAtom with:", fetchedData);
    }
  }

  // Render loading or error state
  if (uid && isLoading) return <div>Loading...</div>;
  if (uid && isError) return <div>Error: {error.message}</div>;

  return (
    <>
      <Card className="site-container" style={{ color: "black" }}>
        <CardBody className="d-flex justify-content-around">
          <div>
            <p>SiteID</p>
            <h4>{site?.SiteID || 'N/A'}</h4>
          </div>
          <div>
            <p>Customer</p>
            <h4>{site?.Customer || 'N/A'}</h4>
          </div>
          <div>
            <p>UID</p>
            <h4>{site?.SiteUID || 'N/A'}</h4>
          </div>
          <div>
            <p>LastRx</p>
            <h4>{site?.LastRx || 'N/A'}</h4>
          </div>
        </CardBody>
      </Card>
    </>
  );
}

